import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent, updateCurrentScreen } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationFormInstructionData,
    selectApplicationFormInstructionStatus,
    selectApplicationFormInstructionError,
    initializeAsync,
} from "./applicationFormInstructionSlice";

import { Button, Container, Typography, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DesktopHeader } from "../../components/DesktopHeader";
import { useMediaQuery } from "react-responsive";
// Add custom imports here

const ApplicationFormInstruction = () => {
    const data = useSelector(selectApplicationFormInstructionData);
    const status = useSelector(selectApplicationFormInstructionStatus);
    const error = useSelector(selectApplicationFormInstructionError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery({ minWidth: 1180 });

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const handleStartPreQualificationClick = () => {
        userDetails.applicant.currentScreen = "application";
        setUserDetailsNotAsync(userDetails);
        updateCurrentScreen(userDetails, "application", "");
        navigate("/application");
    };

    let body = (
        <>
            <Container className="ApplicationFormInstruction" >
                <Typography variant="h1" component="h1">
                    Let's check
                </Typography>
                <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                    Whether you qualify with a quick 2 minute pre-screen. We do this so you won't waste your time or
                    money ($75 app fee) if you don't qualify.
                </Typography>

                {/* {isDesktop && <DesktopHeader applicant={userDetails.applicant}></DesktopHeader>} */}

                <Button
                    onClick={handleStartPreQualificationClick}
                    color="primary"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ height: "45px" }}
                >
                    Continue
                </Button>
            </Container>
        </>
    );

    return getPageContent(body, status, error);
};

export { ApplicationFormInstruction };
